import ObscuredLineTypes from './obscuredLineTypes';

const DefaultDxfHeaderVariables = {
    DRAGVS: 'NULL',
    INTERFERECOLOR: 1,
    INTERFEREOBJVS: 'Conceptual',
    INTERFEREVPVS: '3d Wireframe',
    OBSLTYPE: ObscuredLineTypes.Off,
    SHADEDIF: 70,
};

export default DefaultDxfHeaderVariables;
